//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueSignature from './vueSignature'
import { base64ToBlob, Base64, rotateBase64Img } from '@/tools'
import autographFull from './autographFull.vue'
export default {
  props: {
    questionsList: {
      type: Array,
      default: () => [],
    },
  },
  components: { vueSignature },
  data() {
    return {
      width: '300',
      hasLine: false,
      disabled: false,
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: '#f7f8fa',
      },
    }
  },
  methods: {
    async submit(flag) {
      let _this = this
      let jpeg = _this.$refs.signature.save('image/jpeg')
      let file = base64ToBlob(jpeg, `签名${new Date().getTime()}`)
      if (this.ssdpRequestDtgw1) {
        try {
          const result = await this.requestUploadFile(file);
          this.chooseItem({ ...result, fileName: file.name, url: URL.createObjectURL(file) });
        } catch (error) {
          this.chooseItem(null);
        }
      } else {
        const result = URL.createObjectURL(file);
        this.chooseItem({ path: result, fileName: file.name, url: result });
      }
    },
    clear() {
      let _this = this
      _this.hasLine = false
      _this.$refs.signature.clear()
    },
    chooseItem(item) {
      this.$emit('onchoose', item)
    },
    openAutograph() {
      let _this = this
      let popup = new this.$Popup(autographFull, {
        position: 'bottom',
        isMaskClose: true,
        size: '100%',
        url: _this.hasLine ? _this.$refs.signature.save('image/jpeg') : null,
        onchoose(item) {
          _this.clear()
          _this.$refs.signature.fromDataURL(item, {}, () => {
            let jpeg = _this.$refs.signature.save('image/jpeg')
            rotateBase64Img(jpeg, 270, (data) => {
              _this.$refs.signature.fromDataURL(data, {}, () => {
                _this.hasLine = true
                _this.submit()
                popup.close()
              })
            })
          })
          // _this.$nextTick(() => {
          //   _this.$refs.signature.fromDataURL(item, {}, () => {
          //     _this.$nextTick(() => {
          //       _this.hasLine = true
          //       _this.submit()
          //       popup.close()
          //     })
          //   })
          // })
        },
        onclose() {
          _this.cancel()
          popup.close()
        },
      })
      this.popupItem = popup
    },
    onFull() {
      this.openAutograph()
    },
    cancel() {
      this.clear()
      this.$emit('popup-close')
    },
    requestUploadFile(file) {
      let param = new FormData()
      param.append('file', file)
      param.append('userCode', this.user ? this.user.ldap : '')
      param.append('category', 'form')
      return this.ssdpRequestDtgw1({
        code: 'survey_upload',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_UPLOAD',
          'content-type':'multipart/form-data'
        },
        data: param,
      })
        .then(
          ({
            data: {
              RESPONSE: { RETURN_CODE, RETURN_DATA, RETURN_DESC },
            },
          }) => {
            if (!['S000A000', 'S0A00000', 'S1A00000'].includes(RETURN_CODE)) {
              return Promise.reject(typeof RETURN_DESC === 'string' ? RETURN_DESC : RETURN_DESC.RETURN_DESC);
            } else {
              return Promise.resolve(
                RETURN_DATA
                  ? JSON.parse(Base64.decode(RETURN_DATA))
                  : RETURN_DATA
              )
            }
          }
        )
        .catch((err) => {
          console.error('上传失败', err)
          var msg =
            err && err.RETURN_DESC
              ? err.RETURN_DESC
              : '上传失败，请稍后重试！'
          new this.$Dialog({
            title: '温馨提示',
            text: msg,
            theme: 'ios',
            isConfirm: false,
          });
          return Promise.reject(err);
        })
    },
    openFile(filename, atturl) {
      let fileType = this.getFileType(filename)
      if (this.platform === 3) {
        this.onPreviewAttachment(fileType, atturl)
      } else {
        this.openFileWithGETMethod(filename, atturl)
      }
    },
    openFileWithGETMethod(filename, atturl) {
      console.log(atturl)
      atturl &&
        crh.openFileWithGETMethod({
          param: {
            fileunid: md5(filename),
            file_name: filename,
            download_url: atturl,
            model_name: 'unknow',
            file_encrypt_type: '0',
          },
        })
    },
    onPreviewAttachment(fileType, atturl) {
      const loading = new this.$Loading()
      // atturl &&
      //   jssdk('biz.util.openDocument', {
      //     url: atturl,
      //     fileType,
      //   })
      //     .then(() => {
      //       loading.close()
      //     })
      //     .catch((err) => {
      //       loading.close()
      //       console.log(err)
      //       new this.$Dialog({
      //         title: '温馨提示',
      //         text: '暂不支持打开此格式的文件',
      //         theme: 'ios',
      //         isConfirm: false,
      //       })
      //     })
      atturl &&
        window.tt.openDocument({
          filePath: atturl,
          fileType,
          success(res) {
            console.log(JSON.stringify(res));
            loading.close()
          },
          fail(res) {
            console.log(`openDocument fail: ${JSON.stringify(res)}`);
            loading.close()
            new this.$Dialog({
              title: '温馨提示',
              text: '暂不支持打开此格式的文件',
              theme: 'ios',
              isConfirm: false,
            })
          },
        });
    },
  },
  mounted() {
    let _this = this
    _this.hasLine = false
    this.width = `${_this.$refs.signatureContent.offsetWidth}`
    _this.$refs.signature.$el.firstChild.addEventListener('touchstart', () => {
      _this.hasLine = true
    })
    _this.$refs.signature.$el.firstChild.addEventListener('click', () => {
      _this.hasLine = true
    })
  },
}
